import { writable } from "svelte/store"
import { sessions } from "./lib/firebase"
import generateNewGame from "./lib/generateNewGame"

let live = {
  gameId: false,
  me: false,
  session: false,
}

export const me = writable(false)
export const master = writable(false)
export const gameId = writable(false)
export const session = writable(false)
export const participants = writable(false)
export const initialized = writable(false)

gameId.subscribe(async (id) => {
  if (id) {
    let sess = await sessions.doc(id).get()
    if (!sess.data()) {
      await sessions.doc(id).set(generateNewGame())
      sess = await sessions.doc(id).get()
    }
    sessions.doc(id).onSnapshot(function (doc) {
      session.set(doc.data())
    })
    live.session = sess
    session.set(sess.data())
    live.gameId = id
    joinGame()
  }
})
me.subscribe(async (me) => {
  live.me = me
  joinGame()
})
function joinGame() {
  if (live.me && live.gameId) {
    update("participants.%u", live.me)
  }
}

export const update = (path, value) => {
  path = path.replace("%u", live.me.id)
  sessions.doc(live.gameId).update({
    [path]: value,
  })
}
